enum HttpStatusCode {
  Unauthorized = 401,
  Success = 200,
  NotFound = 404,
}

export default HttpStatusCode;
